import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Content from './Content'
import { actions } from '../../store'

const mapStateToProps = state => ({
  storage: state.storage,
  download: state.download
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getStorage: actions.storage.getStorage,
  getTags: actions.tag.getTags,

  setTable: actions.storage.setTable,
  setFilterTable: actions.storage.setFilterTable,
  setModal: actions.modal.setModal,

  clearFilters: actions.storage.clearFilters,
  clearDownloadList: actions.storage.clearDownloadList
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Content)



// WEBPACK FOOTER //
// ./src/views/Content/index.js